export default __webpack_public_path__ + "static/media/gallery_00.8947a4d4.jpg";